module.exports = __webpack_public_path__ + "r-v3/img/ico_partcipant_white.dd8bd26b.svg";